// ProgressBarControlView.js

import { View } from 'backbone';

import BaseControlView from 'BaseControlView.js';
import template from 'advanced-visuals/control_progress_bar.ejs';
import listService from 'ListService.js';
import eventBus         from 'EventBus.js';
import constants        from "Constants.js";

//=====================================================================
//
// An instance of this view represents a progress bar control
//
// Maty Rocha, February 15, 2016
//
//=====================================================================
class ProgressBarControlView extends BaseControlView  {

    initialize( opts ) {

        super.initialize( opts );

        this.template = template;
        this.tagName = 'div';

        this.listenTo( eventBus, constants.EV_UPDATE_MARGIN_FROM_FORM, this.mobileMarginChangeRender);

        return this;
    }

    updateProgressBar(){
        if (this.model.attributes.autoValue){
            let pageCount= listService.pageCount;
            let currentPage= listService.getPage(listService.currentPageId);         
        
           if(currentPage.model.attributes.pageNumber === 1){
               this.model.set('value', '0', {silent: true}); 
           }else{
               let percentagePerPage = parseInt(100 / pageCount);
               let perAssign = (currentPage.model.attributes.pageNumber -1) * percentagePerPage;
               this.model.set('value', perAssign.toString()); 
          }
       }
    }

    // Neighbor aligner uses this polymorphic property, looking for
    // value 'BaseStaticTextControl'
    get kind() {
        return 'ProgressBarControlView';
    }


}

export default ProgressBarControlView;

